import { jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { useConfig } from "../../contexts/config-context.js";
import styles from "./time-field.module.scss";
import { Fieldset } from "../fieldset/fieldset.js";
import { TimePickerWUT } from "../time-picker/time-picker-wut.js";
function TimeField({
  use24HourFormat = false,
  onBlur,
  onChange,
  onFocus,
  inputId,
  ariaLabelledBy,
  value,
  id,
  disabled,
  readOnly,
  error,
  hidePlaceholder,
  required,
  ariaDescribedBy
}) {
  const { isMobile } = useConfig();
  return /* @__PURE__ */ jsx(
    Fieldset,
    {
      id: inputId,
      onFocus,
      onBlur,
      ariaLabelledBy,
      className: classNames(styles.fields, { [styles.mobile]: isMobile }),
      ariaDescribedBy,
      required,
      children: /* @__PURE__ */ jsx(
        TimePickerWUT,
        {
          inputId,
          disabled,
          readOnly,
          error,
          hidePlaceholder,
          required,
          className: styles.time,
          "data-hook": id,
          use24Hours: use24HourFormat,
          onChange,
          value
        }
      )
    }
  );
}
export {
  TimeField
};
//# sourceMappingURL=time-field.js.map
